/** Textos da secção "benefits" (benefícios do simulador VIP). Chaves planas "benefits.*". */
const pt = {
    // Painel
    "benefits.title": "Benefícios extra",
    "benefits.lead1":
        "Escolhe o patamar de budget de simulação (podes simular um patamar abaixo do total do kit). Se subires o patamar acima do total, precisas de mais itens ou confirmas na mesma. Valor final ",
    "benefits.leadNegotiable": "negociável com admins",
    "benefits.lead2": ".",
    "benefits.budgetEstimated": "Budget estimado",
    "benefits.totalEstimated": "Total estimado (kit + extras)",
    "benefits.budgetAboveWarn":
        "O patamar R$ {budget} está acima do total actual. Adiciona itens no kit ou confirma na simulação para desbloquear benefícios desse valor.",
    "benefits.budgetBelowHint": "A simular benefícios do patamar R$ {budget} com kit estimado em {total}.",
    "benefits.tierSection": "Patamar de simulação",
    "benefits.tierAria": "Patamar de budget",
    "benefits.tierInherits": "Tudo do patamar R$ {prev}, mais:",
    "benefits.tierInheritsOnly": "Tudo do patamar R$ {prev}",

    // Cartões
    "benefits.kit.included": "Incluído — grátis (patamar ≥ R$ {amount})",
    "benefits.kit.freeFrom": "Grátis a partir de R$ {amount} de budget de simulação",
    "benefits.capacity": "Mochila",
    "benefits.priceExtra": "+{price} R$",
    "benefits.freeTier": "Grátis (patamar de budget)",
    "benefits.defaultNoCost": "Padrão — sem custo",
    "benefits.availableFrom": "Disponível com budget ≥ R$ {amount}",
    "benefits.mode": "Modo",
    "benefits.lockedBelow": "Bloqueado com budget abaixo de R$ {amount}",
    "benefits.premiumRequires": "Premium — requer patamar ≥ R$ {amount}",
    "benefits.includedNoExtra": "Incluído — sem custo extra",

    // Opções da mochila
    "benefits.backpack.optIncluded": "{label} — incluído no patamar R$ 20",
    "benefits.backpack.optFree": "{label} — grátis (budget ≥ R$ {from})",
    "benefits.backpack.optPrice": "{label} — +{price} R$",

    // Linhas do resumo / fatura
    "benefits.summary.kit": "🎁 Kit Bónus (inventário fixo) — grátis",
    "benefits.summary.backpack": "🎒 {label} no kit{note}",
    "benefits.summary.backpackFree": " — grátis pelo budget",
    "benefits.summary.backpackPrice": " (+{price} R$)",
    "benefits.summary.recyclerFallback": "Recicladora",

    // Diálogo de diferença de budget
    "benefits.gap.title": "Budget acima do total do kit",
    "benefits.gap.p1": "O teu pedido soma ",
    "benefits.gap.p2": " em itens e benefícios já seleccionados. Para simular ",
    "benefits.gap.tierAmount": "R$ {tier}",
    "benefits.gap.p3": " de budget, faltam cerca de ",
    "benefits.gap.p4": " em itens no kit.",
    "benefits.gap.lead": "Neste patamar podes activar benefícios que ainda não cabem no total actual:",
    "benefits.gap.includedIn": "Incluído no patamar R$ {tier}",
    "benefits.gap.inheritsSuffix": " (tudo do R$ {prev}, mais):",
    "benefits.gap.hint":
        "Adiciona mais itens na aba Kit ou reduz o patamar de budget. O valor final continua negociável com admins.",
    "benefits.gap.cancel": "Manter budget actual",
    "benefits.gap.confirm": "Usar R$ {tier} na mesma",
};

const en = {
    // Panel
    "benefits.title": "Extra benefits",
    "benefits.lead1":
        "Pick the simulation budget tier (you can simulate a tier below the kit total). If you raise the tier above the total, you'll need more items or can confirm anyway. Final price ",
    "benefits.leadNegotiable": "negotiable with admins",
    "benefits.lead2": ".",
    "benefits.budgetEstimated": "Estimated budget",
    "benefits.totalEstimated": "Estimated total (kit + extras)",
    "benefits.budgetAboveWarn":
        "The R$ {budget} tier is above the current total. Add items to the kit or confirm in the simulation to unlock that tier's benefits.",
    "benefits.budgetBelowHint": "Simulating R$ {budget} tier benefits with a kit estimated at {total}.",
    "benefits.tierSection": "Simulation tier",
    "benefits.tierAria": "Budget tier",
    "benefits.tierInherits": "Everything from the R$ {prev} tier, plus:",
    "benefits.tierInheritsOnly": "Everything from the R$ {prev} tier",

    // Cards
    "benefits.kit.included": "Included — free (tier ≥ R$ {amount})",
    "benefits.kit.freeFrom": "Free from a R$ {amount} simulation budget",
    "benefits.capacity": "Backpack",
    "benefits.priceExtra": "+{price} R$",
    "benefits.freeTier": "Free (budget tier)",
    "benefits.defaultNoCost": "Default — no cost",
    "benefits.availableFrom": "Available with budget ≥ R$ {amount}",
    "benefits.mode": "Mode",
    "benefits.lockedBelow": "Locked with a budget below R$ {amount}",
    "benefits.premiumRequires": "Premium — requires tier ≥ R$ {amount}",
    "benefits.includedNoExtra": "Included — no extra cost",

    // Backpack options
    "benefits.backpack.optIncluded": "{label} — included in the R$ 20 tier",
    "benefits.backpack.optFree": "{label} — free (budget ≥ R$ {from})",
    "benefits.backpack.optPrice": "{label} — +{price} R$",

    // Summary / invoice lines
    "benefits.summary.kit": "🎁 Bonus Kit (fixed inventory) — free",
    "benefits.summary.backpack": "🎒 {label} in the kit{note}",
    "benefits.summary.backpackFree": " — free with budget",
    "benefits.summary.backpackPrice": " (+{price} R$)",
    "benefits.summary.recyclerFallback": "Recycler",

    // Budget gap dialog
    "benefits.gap.title": "Budget above the kit total",
    "benefits.gap.p1": "Your request adds up to ",
    "benefits.gap.p2": " in items and benefits already selected. To simulate a ",
    "benefits.gap.tierAmount": "R$ {tier}",
    "benefits.gap.p3": " budget, you're about ",
    "benefits.gap.p4": " short in kit items.",
    "benefits.gap.lead": "At this tier you can enable benefits that don't fit the current total yet:",
    "benefits.gap.includedIn": "Included in the R$ {tier} tier",
    "benefits.gap.inheritsSuffix": " (everything from R$ {prev}, plus):",
    "benefits.gap.hint":
        "Add more items in the Kit tab or lower the budget tier. The final price is still negotiable with admins.",
    "benefits.gap.cancel": "Keep current budget",
    "benefits.gap.confirm": "Use R$ {tier} anyway",
};

export default { pt, en };
